let checkValidity = (value, rules) => {
    let isValid = true
    if (!rules) {
        return true
    }

    if (rules.required) {
      const noScripts = /^[a-zA-Z0-9]/
      const isSafeScript = noScripts.test(value)
        isValid = value.trim() !== '' && isSafeScript && isValid
    }

    if (rules.minLength) {
        isValid = value.length >= rules.minLength && isValid
    }

    if (rules.maxLength) {
        isValid = value.length <= rules.maxLength && isValid
    }

    if (rules.email) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
        isValid = pattern.test(value) && isValid
    }

    return isValid
}

export default checkValidity



// WEBPACK FOOTER //
// ./src/components/ContactForm/Validation.js